<template>
  <div>
    <el-scrollbar height="100%" class="ShowCreateMelkUser">
      <!-- <div class="TopShowBackToPage">
        <h1>کارمندان من</h1>

        <div @click="closeAdvisor" class="ShowIconVsIcon">
          <i class="fas fa-arrow-left" style="font-size: 24px"></i>
        </div>
      </div> -->
      <div class="createMelkHeader phoneBookHeader">
        <div class="createMelkHeaderContainer">
          <div class="createMelkHeaderTitle">
            <h1>مباشران من</h1>
          </div>
          <div class="showFormBtn" @click="showFilterOpenHandler">
            <i class="fa-solid fa-plus"></i>
          </div>
          <div @click="closeAdvisor" class="ShowIconVsIcon">
            <i class="fas fa-arrow-left" style="font-size: 24px"></i>
          </div>
        </div>
      </div>

      <div class="phoneBookMain noteBook">
        <div class="phoneBookMainContainer notBook advisors">
          <div class="containerSideForm" :class="{ show: showFilter }">
            <div class="formHeader">
              <div class="formHeaderTitle" v-if="!isEditing">افزودن مباشر</div>
              <div class="formHeaderTitle" v-if="isEditing">ویرایش مباشر</div>
              <div class="formResetBtn" v-if="isEditing" @click="clear_form()">
                مباشر جدید
              </div>
              <div @click="showFilterCloseHandler" class="ShowIconVsIcon">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="formMain">
              <form class="addPhoneForm">
                <div class="formGroup">
                  <div class="picUploudInputWrapper">
                    <div class="customPicUpload">
                      <input
                        type="file"
                        ref="fileInput"
                        accept="image/*"
                        @change="previewImage"
                      />
                      <img
                        v-if="!imageSrc"
                        src="../../assets/img/defaultAvatar.jpg"
                        id="imagePreview"
                        :alt="user_info.nickname"
                      />

                      <img
                        v-if="imageSrc"
                        :src="imageSrc"
                        id="imagePreview"
                        :alt="user_info.nickname"
                      />
                      <div
                        class="picUploudBtn btnUpload"
                        v-if="!imageSrc"
                        @click="openFileInput"
                      >
                        <i class="fa-solid fa-plus"></i>
                      </div>
                      <div
                        class="picUploudBtn btnDelete"
                        v-if="imageSrc"
                        @click.stop="removeImage"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </div>
                    </div>
                    <div class="customUploadTitle">انتخاب عکس پروفایل</div>
                    <!-- <div class="picUploudBtns">
                      <div
                        class="picUploudBtn"
                        v-if="!imageSrc"
                        @click="openFileInput"
                      >
                        <div class="btnIcon">
                          <i class="fa-solid fa-upload"></i>
                        </div>
                        <div class="btnTitle">آپلود</div>
                      </div>
                      <div
                        class="picUploudBtn"
                        v-if="imageSrc"
                        @click="openFileInput"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-edit"></i>
                        </div>
                        <div class="btnTitle">ویرایش</div>
                      </div>

                      <div
                        class="picUploudBtn btnDelete"
                        v-if="imageSrc"
                        @click.stop="removeImage"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-trash-alt"></i>
                        </div>
                        <div class="btnTitle">حذف</div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="groupFlex">
                  <div class="formGroup">
                    <label class="formGroupLabel">نام‌</label>
                    <input
                      type="text"
                      class="formGroupTextInput"
                      v-model="user_info.fname"
                      maxlength="50"
                    />
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">نام‌خانوادگی</label>
                    <input
                      type="text"
                      class="formGroupTextInput"
                      v-model="user_info.lname"
                      maxlength="50"
                    />
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">تلفن همراه</label>
                    <input
                      type="tel"
                      class="formGroupTextInput"
                      v-model="user_info.mobile"
                      maxlength="11"
                      pattern="[0-9]*"
                      @input="
                        user_info.mobile = user_info.mobile.replace(/\D/g, '')
                      "
                    />
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">تخصص</label>
                    <input
                      type="text"
                      class="formGroupTextInput"
                      v-model="user_info.expert"
                    />
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">سابقه</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput"
                      v-model="user_info.resume"
                    />
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">وضعیت</label>
                    <el-select v-model="user_info.status">
                      <el-option
                        v-for="item in status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                  <div class="formGroup">
                    <label class="formGroupLabel">جنسیت</label>
                    <el-select v-model="user_info.sex">
                      <el-option
                        v-for="(item, i) in sex"
                        :key="i"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                  <!-- <div class="formGroup">
                    <label class="formGroupLabel">تاریخ تولد</label>
                    <DatePicker
                      v-model="user_info.birthday"
                      input-format="jYYYY-jMM-jDD"
                      format="YYYY-MM-DD"
                      :column="1"
                      mode="single"
                    >
                      <template #footer> تاریخ انتخابی: </template>
                    </DatePicker>
                  </div> -->
                  <div class="formGroup">
                    <label class="formGroupLabel">کدملی</label>
                    <input
                      type="text"
                      inputmode="numeric"
                      class="formGroupTextInput"
                      v-model="user_info.code_melli"
                      maxlength="10"
                    />
                  </div>
                  <div class="formGroup fullGroup">
                    <label class="formGroupLabel">آدرس</label>
                    <input
                      type="text"
                      class="formGroupTextInput"
                      v-model="user_info.address"
                      maxlength="100"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div class="formSubmitBtnWrapper">
              <div
                class="formSubmitBtn"
                v-if="!btn_loading && !isEditing"
                @click="send_data('save', true)"
              >
                افزودن مباشر
              </div>
              <div
                class="formSubmitBtn"
                v-if="!btn_loading && isEditing"
                @click="send_data('update', true)"
              >
                ویرایش مباشر
              </div>
              <div class="formSubmitBtn" v-if="btn_loading">
                <span class="loading"></span>
              </div>
            </div>
          </div>
          <div class="containerMainContent">
            <div class="contentHeader">
              <div class="headerSearchInput advisorSearchInput">
                <div class="searchInputWrapper">
                  <input
                    type="search"
                    class="searchInput"
                    v-model.trim="inputSearch"
                    inputmode="search"
                    enterkeyhint="search"
                    placeholder="جستجوی مباشر"
                  />
                  <div class="searchBtn">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
                <div class="sortInputWrapper">
                  <el-select v-model="activeTag">
                    <el-option
                      v-for="tag in tags"
                      :key="tag"
                      :label="tag"
                      :value="tag"
                    />
                  </el-select>
                </div>
              </div>
              <div class="headerTitleWrapper">
                <div class="headerTitle">لیست مباشران</div>
              </div>
            </div>
            <div class="contentMain">
              <div v-if="isLoading" class="usersList">
                <skeletor class="advisorThumbSk" v-for="i in 4" :key="i" />
              </div>
              <div
                v-if="!isLoading && searchResult.length > 0"
                class="usersList"
              >
                <div
                  class="userThumb advisorThumb"
                  v-for="(user, i) in searchResult"
                  :key="i"
                >
                  <router-link
                    :to="`/profile-superior?uid=${user.uid}`"
                    style="width: 100%"
                  >
                    <div class="userInfo advisorsInfo">
                      <div class="userPorile">
                        <img :src="user.avatar" :alt="user.firstname" />
                      </div>
                      <div class="userInfos">
                        <div class="infoName">{{ user.nickname }}</div>
                        <div class="infoLoc">{{ user.sex[1] }}</div>
                      </div>
                    </div>
                  </router-link>
                  <div class="userBtnsWrapper">
                    <div
                      v-if="editLoading != user.uid"
                      class="userBtn editBtn"
                      @click="form_modal('edit', user.uid)"
                    >
                      <div class="btnIcon">
                        <i class="fas fa-edit"></i>
                      </div>
                      <div class="btnTitle">ویرایش</div>
                    </div>
                    <div v-if="editLoading == user.uid" class="userBtn editBtn">
                      <span class="editLoader"></span>
                    </div>
                    <div class="userBtn deleteBtn" @click="del_user(user.uid)">
                      <div class="btnIcon">
                        <i class="fas fa-trash-alt"></i>
                      </div>
                      <div class="btnTitle">حذف</div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="searchResult.length == 0 && !isLoading"
                class="justify-center align-center mt-4 col-span-12 grid"
                style="text-align: center; height: 90%"
              >
                <img
                  src="/img/notfound.png"
                  alt="Alt text"
                  width="320"
                  height="280"
                />
                <p class="noResultContent">مباشری یافت نشد!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
// import DatePicker from "@alireza-ab/vue3-persian-datepicker";
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";
import Compressor from "compressorjs";
import axios from "axios";

export default {
  name: "MyAdvisors",
  components: {
    Skeletor,
  },
  data() {
    return {
      // publicPath: process.env.VUE_APP_PUBLIC_PATH,
      color: "#2dc653",
      showAdvisors: false,
      activeTag: "all",
      tags: ["همه", "زن", "مرد"],
      inputSearch: "",
      imageSrc: null,
      isEditing: false,
      status: [
        { value: "active", label: "فعال" },
        { value: "deactive", label: "غیرفعال" },
        { value: "valid_active", label: "فعال برتر" },
      ],
      sex: [
        { value: "man", label: "مرد" },
        { value: "woman", label: "زن" },
      ],
      btn_loading: false,
      consultant_list: [],
      isLoading: false,
      editLoading: null,
      user_info: {
        avatar: "",
        uid: "",
        fname: "",
        lname: "",
        mobile: "",
        expert: "",
        code_melli: "",
        birthday: "",
        resume: "",
        address: "",
        role: "consultant",
        sex: "man",
        status: "active",
      },
      form_mode: "save",
      current_img: [],
      has_avatar: false,
    };
  },
  computed: {
    searchResult() {
      return this.consultant_list.filter(
        (consultant_list) =>
          (this.activeTag === "all" ||
            consultant_list.sex.includes(this.activeTag)) &&
          consultant_list.nickname
            .toLowerCase()
            .includes(this.inputSearch.toLowerCase())
      );
    },
    showFilter() {
      return this.$route.query.advisor == "active" ? true : false;
    },
  },
  watch: {
    showFilter() {
      if (!this.showFilter) {
        this.clear_form();
      }
    },
  },
  methods: {
    showFilterOpenHandler() {
      this.$router.push({
        query: {
          ...this.$route.query,
          advisor: "active",
        },
      });
    },
    showFilterCloseHandler() {
      // this.showFilter = false;
      this.editLoading = null;
      history.back();
      this.clear_form();
    },
    clear_form() {
      this.user_info = {
        avatar: "",
        uid: "",
        fname: "",
        lname: "",
        mobile: "",
        expert: "",
        code_melli: "",
        birthday: "",
        resume: "",
        address: "",
        role: "consultant",
        sex: "man",
        status: "active",
      };
      this.imageSrc = null;
      this.isEditing = false;
      this.current_img = [];
    },
    load_users() {
      this.isLoading = true;
      this.helperPost("branch-users-list", { role: "consultant" })
        .then((r) => {
          this.consultant_list = r.data.list;
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },
    openAdvisor() {
      this.showAdvisors = true;
      document.body.style.overflow = "hidden";
    },
    closeAdvisor() {
      history.back();
      this.showAdvisors = false;
      document.body.style = "overflow-y: auto";
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    async previewImage(event) {
      var self = this;
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);

      new Compressor(file, {
        quality: 0.6,

        // The compression process is asynchronous,
        // which means you have to access the `result` in the `success` hook function.
        success(result) {
          self.current_img.push(result);
        },
        error(err) {
          console.log(err.message);
        },
      });
    },
    async uploadavatar(uid) {
      var self = this;
      const formData = new FormData();

      const compressed = await new Promise((resolve, reject) => {
        new Compressor(this.current_img[0], {
          quality: 0.6,
          success: (result) => resolve(result),
          error: (err) => reject(err),
        });
      });

      // The third parameter is required for server
      formData.append("avatar", compressed, compressed.name);
      formData.append("uid", uid);
      formData.append("from", "consultant");

      console.log("this.current_img", this.current_img[0], formData);

      axios
        .post(self.$store.getters.baseUrl + "/upload-avatar", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Set the content type for file upload
            Authorization: "Bearer " + self.$store.getters.appToken,
          },
        })
        .then(function (response) {
          console.log("response", response);
          if (response.data.result == "1") {
            self.clear_form();
            self.load_users();
            let windowWidth = window.innerWidth;
            if (windowWidth < 1000 && close) {
              self.showFilterCloseHandler();
            }
            setTimeout(() => {
              toast("عملیات با موفقیت انجام شد.", {
                type: "success",
                dangerouslyHTMLString: true,
              });
            }, 250);
          } else {
            toast(response.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
          }
          self.btn_loading = false;
        })
        .catch((err) => {
          console.log(err);
          toast("مشکلی پیش آمده! مجدد امتحان کنید.", {
            type: "error",
            dangerouslyHTMLString: true,
          });
          self.btn_loading = false;
        });
    },
    removeImage() {
      var self = this;

      if (!self.has_avatar) {
        self.imageSrc = null;
        self.$refs.fileInput.value = "";
        self.current_img = [];
        return;
      }
      self.$swal
        .fire({
          title: "حذف تصویر پروفایل",
          text: "آیا از حذف تصویر مطمئن هستید؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "بله مطمئنم",
          cancelButtonText: "لغو",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              self
                .helperGet(
                  "delete-avatar",
                  "from=user&uid=" + this.user_info.uid
                )
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.imageSrc = null;
                    self.$refs.fileInput.value = "";
                    self.has_avatar = false;
                    self.current_img = [];
                  }
                });
            }
          }
        });
    },

    setActiveTag(tag) {
      this.activeTag = tag;
    },

    ShowBtnCreate() {
      this.showAdvisors = false;
    },
    send_data(mode, close = false) {
      this.btn_loading = true;
      let url = "update-profile";
      if (mode == "save") url = "save-profile";

      if (this.user_info.fname == "") {
        toast("نام مباشر را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (this.user_info.lname == "") {
        toast("نام خانوادگی مباشر را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (this.user_info.mobile == "") {
        toast("تلفن همراه مباشر را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (!/^09\d{9}$/.test(this.user_info.mobile)) {
        toast("فرمت تلفن همراه وارد شده صحیح نمی باشد", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      } else if (this.user_info.code_melli == "") {
        toast("کدملی مباشر را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        this.btn_loading = false;
        return;
      }

      this.helperPost(url, this.user_info)
        .then((r) => {
          if (r.data.result == "1") {
            if (this.imageSrc) {
              if (url == "save-profile" && this.current_img)
                this.uploadavatar(r.data.uid);

              if (url == "update-profile" && this.current_img)
                this.uploadavatar(this.user_info.uid);
            } else {
              this.load_users();
              this.clear_form();
              this.btn_loading = false;

              let windowWidth = window.innerWidth;
              if (windowWidth < 1000 && close) {
                this.showFilterCloseHandler();
              }
              this.$nextTick(() => {
                toast(r.data.msg, {
                  type: "success",
                  dangerouslyHTMLString: true,
                });
              });
            }
          } else {
            toast(r.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
            this.btn_loading = false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.btn_loading = false;
          toast("مشکلی پیش آمده! مجدد امتحان کنید.", {
            type: "error",
          });
        });
    },
    get_user_info(uid) {
      let windowWidth = window.innerWidth;
      this.helperGet("branch-user-info", "uid=" + uid).then((res) => {
        res.data.data.has_avatar ? (this.imageSrc = res.data.data.avatar) : "";
        this.has_avatar = res.data.data.has_avatar;
        this.user_info.avatar = res.data.data.avatar;
        this.user_info.uid = res.data.data.uid;
        this.user_info.fname = res.data.data.fname;
        this.user_info.lname = res.data.data.lname;
        this.user_info.mobile = res.data.data.mobile;
        this.user_info.expert = res.data.data.expert;
        this.user_info.code_melli = res.data.data.code_melli;
        this.user_info.birthday = res.data.data.birthday;
        this.user_info.resume = res.data.data.resume;
        this.user_info.address = res.data.data.address;
        this.user_info.sex = res.data.data.sex;
        this.user_info.status = res.data.data.status;
        if (windowWidth < 1000) {
          this.showFilterOpenHandler();
        }
        this.editLoading = null;
      });
    },

    form_modal(mode, uid) {
      if (mode == "edit") {
        this.form_mode = "edit";
        this.get_user_info(uid);
        this.isEditing = true;
        this.editLoading = uid;
        return;
      }
      this.user_info.avatar = "/img/profile.png";
      this.user_info.uid = "";
      this.user_info.fname = "";
      this.user_info.lname = "";
      this.user_info.mobile = "";
      this.user_info.expert = "";
      this.user_info.code_melli = "";
      this.user_info.birthday = "";
      this.user_info.resume = "";
      this.user_info.address = "";
      this.user_info.sex = "man";
      this.user_info.status = "active";
      this.imageSrc = null;
    },
    del_user(uid) {
      this.$swal
        .fire({
          title: "مشاور حذف گردد؟",
          text: "پس از این عملیات مشاور برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("user-delete", { foo: [uid] })
                .then((r) => {
                  if (r.data.result == 1) {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.load_users();
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
  },
  mounted() {
    this.activeTag = "همه";
    this.openAdvisor();
    this.load_users();
  },
};
</script>

<style lang="scss" scoped>
.hover\:bg-indigo-600:hover {
  background: #ade8f4;
}
.active {
  background: #0096c7;
  color: #fff;
  font-family: "iranyekanB";
}
.j-modal > :first-child {
  background: #fbfbfb !important;
}

.userName {
  font-family: "iranyekanB", sans-serif;
  font-size: 1.15rem !important;
}

.userControlBtns {
  & > div {
    display: flex;
    height: 30px;
    width: 80px;
    justify-content: center;
    gap: 5px;
    background: #f00;
    border-radius: 5px;
    align-items: center;
    gap: 5px;

    span {
      font-size: 0.8rem;
      color: #fff;
    }

    &.userEditBtn {
      background: #0096c7;
    }
  }
}

@media screen and (max-width: 640px) {
  .userControlBtns {
    flex-direction: row !important;
    margin-top: 20px;

    & > div {
      width: 48%;
      height: 40px;

      span {
        font-size: 0.9rem;
      }
    }
  }
}
@import url("../../../public/css/tailwindcss.css");
.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.editLoader {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.ShowIconVsIcon,
.showFormBtn {
  width: 32px;
  height: 32px;
}

.noResultContent {
  text-align: center;
  font-size: 0.95rem;
}

.advisorThumbSk {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  background: rgb(163, 219, 213);

  &:not(:last-child) {
    margin-bottom: 16px;
  }
}
</style>
